import api from './api';

const vaultsendemailService = {
  send: async ({ to, subject, html }) => {
    const response = await api.post('/vaultsendemail', { to, subject, html });
    return response.data;
  }
};

export default vaultsendemailService;
